var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4176_13351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4895 7.57696L21.3268 2.73685H15.0526V0H26V10.9474H23.2632V4.6718L18.423 9.51191C20.002 11.5817 20.7354 14.1741 20.4748 16.7643C20.2142 19.3545 18.979 21.7489 17.0193 23.4626C15.0597 25.1763 12.522 26.0813 9.92017 25.9943C7.31835 25.9073 4.84681 24.8348 3.00602 22.994C1.16523 21.1532 0.0927445 18.6817 0.00573894 16.0798C-0.0812666 13.478 0.823707 10.9403 2.53741 8.98069C4.25112 7.02103 6.64548 5.78584 9.23568 5.52521C11.8259 5.26458 14.4183 5.998 16.4881 7.57696H16.4895ZM10.2631 23.2632C12.2592 23.2632 14.1736 22.4702 15.585 21.0588C16.9965 19.6473 17.7895 17.733 17.7895 15.7369C17.7895 13.7408 16.9965 11.8264 15.585 10.415C14.1736 9.00349 12.2592 8.21054 10.2631 8.21054C8.26702 8.21054 6.35267 9.00349 4.94121 10.415C3.52975 11.8264 2.7368 13.7408 2.7368 15.7369C2.7368 17.733 3.52975 19.6473 4.94121 21.0588C6.35267 22.4702 8.26702 23.2632 10.2631 23.2632Z",
    fill: "url(#paint0_linear_4176_13351)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4176_13351",
    x1: -1.82,
    y1: 29.77,
    x2: 28.99,
    y2: -1.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4176_13351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManLine);
export default __webpack_public_path__ + "static/media/man-line.5d01b38fb17348ed089271848f1b3a55.svg";
export { ForwardRef as ReactComponent };